const employer_uischema = {
  view: "main",
  title: "Employer Profiles",
  entity: "Employers",
  linkBack: {
    name: "Back to Profiles",
    link: "/dashboard/profiles/",
  },
  button: {
    name: "New Employer",
    style: "default",
  },
};

export default employer_uischema;
